/*  MUI  */
import { Avatar } from '@mui/material';

/*  Shared  */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';
import { Storage } from 'application/Shared/Handlers';
import { Helpers, Response } from 'application/Shared/Helpers';
import { Requests } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';

class Image extends Component {
    constructor(props) {
        super(props);
        this.state = {
            image: { src: '' }
        };

        /* requests */
        this.requests = new Requests();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const { imageId, imageData } = this.props;

        if (!imageId) {
            return;
        }

        const image = {};

        if (imageData) {
            image.src = imageData;
            this.setState({ image });
        }

        if (imageId === '') {
            return;
        }

        try {
            const storageImg = await Storage.get(`image_${imageId}`);

            if (storageImg) {
                image.src = storageImg;
            } else {
                let response;
                try {
                    response = await axios.get('/image', {
                        cancelToken: this.requests.token(),
                        params: { id: imageId }
                    });
                    if (!Response.hasData(response)) {
                        return;
                    }
                } catch (e) {
                    return;
                }

                const imageResp = Response.getOne(response);
                if (!Helpers.isset(imageResp, 'image', 'data')) {
                    return;
                }

                const { data, type } = imageResp.image;
                const image64 = new Uint8Array(data).reduce(
                    (d, b) => d + String.fromCharCode(b),
                    ''
                );

                image.src = `data:image/${type};base64,${image64}`;

                const key = `image_${imageId}`;
                Storage.set(key, image.src, (v) => {
                    if (v) {
                        return;
                    }

                    // image failed to store
                    debug.e('Failed to store', key);
                });
            }

            this.setState({ image });
        } catch (e) {
            debug.e(e);
        }
    };

    unload = () => {
        this.requests.cancel();
    };

    render() {
        const {
            avatar,
            text,
            style,
            className,
            alt,
            tooltipText,
            tooltipPlacement,
            'aria-label': ariaLabel = 'image'
        } = this.props;
        const { image } = this.state;
        const { src } = image;
        let object = null;

        if (avatar) {
            if (text) {
                object = (
                    <Avatar style={style} className={className} src={src}>
                        {text}
                    </Avatar>
                );
            } else {
                object = (
                    <Avatar style={style} className={className} src={src} />
                );
            }
        } else {
            object = (
                <img
                    alt={alt}
                    aria-label={ariaLabel}
                    className={className}
                    src={src}
                    style={style}
                />
            );
        }

        if (tooltipText) {
            object = (
                <DarkTooltip
                    arrow
                    title={tooltipText}
                    placement={tooltipPlacement || 'bottom'}
                >
                    {object}
                </DarkTooltip>
            );
        }

        return object;
    }
}

export default Image;
